







































import Vue from 'vue'
import SimpleModalLayout from '@/components/modal/basics/SimpleModal/SimpleModalLayout.vue'
import SvgElement from '@/components/globals/SvgElement.vue'

export default Vue.extend({
  components: {
    SimpleModalLayout,
    SvgElement,
  },
  methods: {
    handleClose() {
      this.$modal.pop()
    },
  },
})
